import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ManutencaoSincronizarProcessosComponent } from './manutencao-sincronizar-processos/manutencao-sincronizar-processos.component';
import { ManutencaoProcessarDocumentoComponent } from './manutencao-processar-documentos/manutencao-processar-documentos.component';
import { ManutencaoReprocessarDocumentoComponent } from './manutencao-reprocessar-documentos/manutencao-reprocessar-documentos.component';
import { ManutencaoSincronizarProcessosAssociacoesComponent } from './manutencao-sincronizar-processos-associacoes/manutencao-sincronizar-processos-associacoes.component';

const routes: Routes = [
  { path: 'manutencao/sincronizarProcessos', component: ManutencaoSincronizarProcessosComponent, data: { titulo: 'Sincronizar Processos' }  },
  { path: 'manutencao/processarDocumentos', component: ManutencaoProcessarDocumentoComponent, data: { titulo: 'Processar Documentos' }  },
  { path: 'manutencao/reprocessarDocumentos', component: ManutencaoReprocessarDocumentoComponent, data: { titulo: 'Reprocessar Documentos' }  },
  { path: 'manutencao/sincronizarProcessosAssociacoes', component: ManutencaoSincronizarProcessosAssociacoesComponent, data: { titulo: 'Sinc. Processos Associações' }  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ManutencaoRoutingModule { }
